import { render, staticRenderFns } from "./LicencesEmployee.vue?vue&type=template&id=0cd4cb1a&scoped=true&"
import script from "./LicencesEmployee.vue?vue&type=script&lang=js&"
export * from "./LicencesEmployee.vue?vue&type=script&lang=js&"
import style0 from "./LicencesEmployee.vue?vue&type=style&index=0&id=0cd4cb1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd4cb1a",
  null
  
)

export default component.exports